import React from 'react';
import { useTranslation } from 'react-i18next';
import SumsubWebSdk from '@sumsub/websdk-react';
import { authService } from 'api/auth';

interface SumsubVerificationProps {
  accessToken: string;
  onMessage?: (type: string, payload: unknown) => void;
  onError?: (error: unknown) => void;
}

const SumsubVerification: React.FC<SumsubVerificationProps> = ({
  accessToken,
  onMessage,
  onError,
}) => {
  const { i18n } = useTranslation();

  return (
    <SumsubWebSdk
      accessToken={accessToken}
      expirationHandler={async () => {
        try {
          const response = await authService.getSumsubToken();
          return response?.data?.token || accessToken;
        } catch (e) {
          console.error('Failed to refresh Sumsub token', e);
          return accessToken;
        }
      }}
      config={{
        lang: i18n.language || 'en',
        onMessage: (type: string, payload: unknown) => {
          console.log('Sumsub message:', type, payload);
          if (onMessage) onMessage(type, payload);
        },
        onError: (error: unknown) => {
          console.error('Sumsub error:', error);
          if (onError) onError(error);
        },
      }}
      options={{
        adaptive: true,
      }}
    />
  );
};

export default SumsubVerification;
